import { render, staticRenderFns } from "./WorkoutRow.vue?vue&type=template&id=2838cffc&scoped=true&"
import script from "./WorkoutRow.vue?vue&type=script&lang=js&"
export * from "./WorkoutRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838cffc",
  null
  
)

export default component.exports